import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { Link } from 'react-router-dom';
import MonthBoxGrid from './MonthBoxGrid';
import { getGrowthTime, formatDateRange, getAllWindowRanges, getWindowDates } from "../utils/cropUtils";

/**
 * Table component for displaying crops
 */
const CropsTable = ({ crops, columns }) => {
  const renderCell = (crop, column, key) => {
    const columnClass = `column-${column}`;

    switch (column) {
      case 'name':
        return <TableCell key={key} className={columnClass}>{crop.name}</TableCell>;
      
      case 'soil_effect':
        return <TableCell key={key} className={columnClass}>{crop.soil_effect}</TableCell>;
      
      case 'growth_time':
        return <TableCell key={key} className={columnClass}>{getGrowthTime(crop)}</TableCell>;
      
      case "grid": {
        const ranges = getAllWindowRanges(crop);
        return (
          <TableCell
            key={key}
            className={`grid-column-cell ${columnClass}`}
            style={{ minWidth: "320px" }}
          >
            <MonthBoxGrid ranges={ranges} />
          </TableCell>
        );
      }
      
      default: {
        // Handle period type columns (pre_germination, direct_sowing, etc.)
        const periodTypes = ['pre_germination', 'direct_sowing', 'setting', 'planting', 'pruning', 'harvest', 'picking'];
        if (periodTypes.includes(column)) {
          const periodData = getWindowDates(crop, column);
          return (
            <TableCell key={key} className={columnClass}>
              {formatDateRange(periodData.start, periodData.end)}
            </TableCell>
          );
        }
        return <TableCell key={key} className={columnClass}>-</TableCell>;
      }
    }
  };

  return (
    <TableContainer component={Paper} className="crops-table">
      <Table>
        <TableHead>
          <TableRow>
            {columns.headers.map((header, index) => {
              const column = columns.columns[index];
              const columnClass = `column-${column}`;
              return (
                <TableCell key={index} className={columnClass}>
                  {header}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {crops.map((crop) => (
            <TableRow
              key={crop.crop_uuid}
              component={Link}
              to={`/crops/${crop.crop_uuid}`}
              style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
            >
              {columns.columns.map((column, index) => 
                renderCell(crop, column, `${crop.crop_uuid}-${column}-${index}`)
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CropsTable;



